export const ADD_PRODUCT = "ADD_PRODUCT";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const CLEAR_CART = "CLEAR_CART";
export const FETCH_BASKET_DATA = "FETCH_BASKET_DATA";
export const REMOVE_FROM_BASKET = "REMOVE_FROM_BASKET";
